import React, {
	useEffect,
	useRef,
	useState
} from 'react';
import classNames from 'classnames';

import { FiChevronDown } from 'react-icons/fi';
import {
	Accordion,
	AccordionItem,
	AccordionControl,
	AccordionPanel
} from '../Accordion';
import AccountButton from '../AccountButton/AccountButton';
import Link from '../Link';
import NavSubMenu from '../NavSubMenu';
import RenderStaticHTML from '../RenderStaticHTML';

import { useAddKeyProp, useKeypressHandler } from '../../utils/hooks';
import renderIcon from '../../utils/renderIcon';

const ns = `nav-mobile-menu`;

const NavMobileMenu = ({
	menuItems,
	navigationText,
	onCloseCallback,
	open = false,
	collapseMenuOnClose = false,
	currentPathname,
}) => {
	const keyedMenuItems = useAddKeyProp(menuItems, 'burnham');
	const [subMenuItems, setSubMenuItems] = useState();
	const [nonSubMenuItems, setNonSubMenuItems] = useState();
	const accordionInstanceRef = useRef(); // Used to interact w/ Accordion imperatively.
	useKeypressHandler('Escape', onCloseCallback);

	const navItemClickHandler = () => {
		(typeof onCloseCallback === 'function' && onCloseCallback());
		accordionInstanceRef.current.collapseAll();
	};

	useEffect(() => {
		collapseMenuOnClose && !open && accordionInstanceRef.current.collapseAll();
	}, [collapseMenuOnClose, open]);

	useEffect(() => {
		if (keyedMenuItems) {
			setSubMenuItems(keyedMenuItems.filter(item => {
				return item.dropdown?.column;
			}));
			setNonSubMenuItems(keyedMenuItems.filter(item => {
				return !item.dropdown?.links && item.optionalUrl;
			}));
		}
	}, [keyedMenuItems]);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--closed`]: !open,
	});

	return (
		<div className={rootClassnames}>
			<div
				className={`${ ns }__overlay`}
				onClick={onCloseCallback}
				aria-hidden
			/>
			<div className={`${ ns }__panel`}>
				<button className={`${ ns }__close`} onClick={onCloseCallback}>
					<span className={`visually-hidden`}>Close menu</span>
					<span aria-hidden>{renderIcon('close')}</span>
				</button>
				<div
					className={`${ ns }__content`}
				>
					{subMenuItems?.length && (
						<Accordion
							className={`${ ns }__accordion`}
							ref={accordionInstanceRef}
							// allowMultipleExpanded
						>
							{
								subMenuItems.map(({key, label, dropdown}) => {
									return (
										<AccordionItem key={key}>
											<AccordionControl
												className={`${ ns }__item-heading`}
											>
												<span className={`h4`}>{label}</span>
												<span className={`${ ns }__icon`}>
													<FiChevronDown size={20} />
												</span>
											</AccordionControl>
											<AccordionPanel
												render={expanded => {
													return (
														<NavSubMenu
															key={`sub-menu-${ key }`}
															menuItems={dropdown?.column}
															active={expanded}
															currentPathname={currentPathname}
															onClick={navItemClickHandler}
														/>
													);
												}}
											/>
										</AccordionItem>
									);
								})
							}
						</Accordion>
					)}
					<div className={`${ ns }__non-submenu-links`}>
						{
							nonSubMenuItems
							&& (
								nonSubMenuItems.map(({label, optionalUrl, key}) => {
									return (
										<div className={`${ ns }__non-submenu-link ${ ns }__item-heading`} key={key}>
											<Link
												to={optionalUrl}
												onClick={onCloseCallback}
											>
												<span className={`h4`}>{label}</span>
											</Link>
										</div>
									);
								})
							)
						}
					</div>
					<div className={`${ ns }__account`}>
						<AccountButton closeMenu={navItemClickHandler} />
					</div>
					{
						navigationText && (
							<div className={`${ ns }__info`}>
								<RenderStaticHTML
									className={`text-small`}
									html={navigationText}
								/>
							</div>
						)
					}
				</div>
			</div>
		</div>
	);
};

export default NavMobileMenu;
